import * as React from 'react';
import { useState, useEffect } from "react";
import Modal from "../../../component/Global/Modal";
import { useQuoteStore } from 'src/hooks/quote';
import QuoteDetailRepository from 'src/repository/QuoteDetailRepository';
import { useQuoteDetailStore } from 'src/hooks/quote-detail';
import QuoteConfig from "@system/config/quote";
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import produceClone from 'src/helper/produceClone';
import { useBOMStore } from "src/hooks/bom";
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import { useBOMProjectStore } from "src/hooks/bom_project";
import { useProductPricingStore } from "src/hooks/productPricing";
import { useProductInventoryStore } from "src/hooks/productInventory";


const ValidateRFQQuoteRequest = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const [status, SetStatus] = useState(false);
    const [selectedQuoteList, SetSelectedQuoteList] = useState([]);
    const [{ }, { }, { add_multiple_quote }] = useQuoteStore();
    const [{ get_current_quote_cart }, { }, { select_all_quantity }] = useQuoteDetailStore();
    const quoteFrom = props.data.quoteFrom;
    const quoteList = props.data.quoteList;
    const [{ bom_detail_by_bom_id ,bom_detail_by_bom_id_type} ] = useBOMStore();
    const [{ bom_project_list }, { }, { }] = useBOMProjectStore();
    const [{ pricingList }, { }, { }] = useProductPricingStore();
    const [{ inventoryList }, {}, {}] = useProductInventoryStore();
    const inventory = inventoryList;

    async function getQuoteData() {
        if (quoteFrom === 'Quote') {
            await setSessionQuoteData();
        } else if (quoteFrom === 'BOMQuote') {
            // Set data with RFQ logic
            const selectedQuote = await new QuoteDetailRepository().setBulkQuoteBOM(quoteList);
            await add_multiple_quote(selectedQuote);
            SetSelectedQuoteList(selectedQuote);
            addQuoteEvent(selectedQuote);
        } else if (quoteFrom === 'CrossReference') {
            const selectedQuote = await new QuoteDetailRepository().setBulkQuoteBOMForCrossReference(quoteList);
            await add_multiple_quote(selectedQuote);
            SetSelectedQuoteList(selectedQuote);
        }
    }

    const setSessionQuoteData = async () => {
        // Set data with RFQ logic
        const selectedQuote = await new QuoteDetailRepository().setQuoteBulk(quoteList);
        await add_multiple_quote(selectedQuote);
        SetSelectedQuoteList(selectedQuote);
        // After success Remove Quote from Redux / session / localStorage
        const currentQuote = (Object.entries(quoteList)[0])[1];
        const quoteStatus = currentQuote.quoteStatus;
        let data = { quoteNumber: currentQuote.quoteNumber, list: {} };
        let sessionQuoteList = get_current_quote_cart(currentQuote.quoteNumber);
        
        if (sessionQuoteList && Object.entries(sessionQuoteList).length > 0) {
            let selectedList = produceClone(sessionQuoteList);
            Object.entries(selectedList).map((v) => {
                if (v[1].quoteStatus !== quoteStatus)
                    data.list[v[0]] = v[1];
            });
        }
        select_all_quantity(data);
    }

    useEffect(() => {
        if (ValidateRFQQuoteRequest) {
            SetStatus(true)
            getQuoteData()
        }

    }, [ValidateRFQQuoteRequest]);



    const onHide = (action = true) => {
        SetStatus(false)
    };

    const onReviewQuote = async () => {

        window.location.href = QuoteConfig.getQuoteRouteURL();
        onHide();
    };

    // 7796 - Update url for Continue Shopping 
    const onContinueShopping = async () => {
        onHide();
    };

    //By Ramya Kannan [Add to cart - Adobe script ]
    function addQuoteEvent(quoteDetails){
        localStorage.setItem("adobeEventType","addToQuoteFromBOM");
        let prodDetails = quoteDetails;
        let getBomDetails = bom_detail_by_bom_id;
        let bomDetails = {...getBomDetails};
        if(bom_project_list){
            bomDetails.projectName = bom_project_list[bomDetails.projectId]?.projectName;
          }
        bomDetails.exactMatchCount = bom_detail_by_bom_id_type?.Exact?.count;
        bomDetails.nomatchCount = bom_detail_by_bom_id_type?.NoMatch?.count;
        bomDetails.multipleMatchCount = bom_detail_by_bom_id_type?.Multiple?.count;
        prodDetails.forEach((data,key)=> {
            prodDetails[key].qas = getInventory(data?.ERPPartNumber || data?.partNumber).qas, //added by Ramya
            prodDetails[key].priceSource = getPricing(data.ERPMFRPartNumber, (data.ERPPartNumber || data?.partNumber), data.ERPPartNumberModified)[0].priceSource;
        })
        let cartDetails = {
            "cartType":"Quote",
            "additionSource" : quoteFrom,
            "quoteID": quoteDetails?.quoteLineItemId,
            "quoteType": "online"

        }
        if(Object.keys(prodDetails).length){
            HelperAdobeEvent.trackingAdobeEvent({prodDetails,cartDetails,bomDetails});
        }
    }

    //added by Ramya [Adobe script]
  const getInventory = (ERPPartNumber) => {
    if (inventory[ERPPartNumber] !== undefined) {
      return inventory[ERPPartNumber];
    }
    return {
      qas: 0,
      quantity: 0,
    };
  };
  const getPricing = (
    ERPMFRPartNumber,
    ERPPartNumber,
    ERPPartNumberModified
  ) => {
    ERPPartNumber = ERPPartNumberModified ? "" : ERPPartNumber;
    if (pricingList[ERPMFRPartNumber + "-" + ERPPartNumber]) {
      return pricingList[ERPMFRPartNumber + "-" + ERPPartNumber];
    }
    return [];
  };

    return (
        <>
            <Modal show={status} onHide={() => { onHide() }}>
                <div className="avnet-modal modal-630">
                    <div className="avnet-modal-inner">
                        <button type="button" className="close py-3" data-dismiss="modal"
                            onClick={() => { onHide() }}>×</button>
                        <div className="bs5 modal-header border-0">
                            <h3 className="modal-title m-auto" id="exampleModalLabel">Request a Quote</h3>
                        </div>
                        {__check(['QUOTE_API_CALL']).render}
                        {!__check(['QUOTE_API_CALL']).status &&
                            <>
                                <div className="modal-body">
                                    <div className="alert alert-success alert-dismissible mb-3">
                                        <span>You've added parts to your open quote.<br />
                                            Quantity has been updated to reach the minimum quote value.
                                        </span>
                                    </div>
                                    <div className='m-b-10 font-16'>
                                    </div>
                                    <div className="mb-3 rfq-popup-table">
                                        <table className="bs5 table table-bordered table-striped">
                                            <thead>
                                                <tr>
                                                    <th className="bs5 text-capitalize font-13 col-8">Part Number/Manufacturer</th>
                                                    <th className="bs5 text-capitalize font-13 col-4">Quantity</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {Object.values(selectedQuoteList).map((v, i) => (
                                                    <tr key={i}>
                                                        <td className="col-8">
                                                            <strong>{v.ERPMFRPartNumber}</strong>
                                                            <div>
                                                                {v.manufacturerName}
                                                            </div>
                                                        </td>
                                                        <td className="col-4">
                                                            {v.quantity1}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="text-center quote-popup-text">
                                        <b className="d-block">You will still need to submit the quote in order to receive a response.</b>
                                        Review your quotes details by clicking the green button below or continue
                                        shopping and return to the open quote when ready.
                                    </div>
                                </div>
                                <div className="modal-footer d-flex justify-content-center">
                                    <button type="button" className="bs5 btn btn-secondary"
                                        onClick={() => { onContinueShopping() }}>continue shopping</button>
                                    <button type="button" className="bs5 btn btn-primary"
                                        onClick={() => onReviewQuote()}>review quote</button>
                                </div>
                            </>
                        }
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default ValidateRFQQuoteRequest;